import React from 'react'
import healthcare1 from '../images/mlh1.png';
import healthcare2 from '../images/mlh2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function MyLondonHome() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">MyLondonHome</span> – Comprehensive Real-Estate & Brokerage Management System
                    </div>
                </div>
            </section>

            <section className="container my-5">

                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="MyLondonHome Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">MyLondonHome</span> – Real-Estate & Brokerage Management Software
                        </h1>

                        <p className="mb-3 ps-1">
                            MyLondonHome is a fully tailored real-estate and brokerage management platform designed to digitalize,
                            automate, and streamline property operations for agencies, brokers, and sales teams. It enables seamless
                            property listing management, client relations, deal tracking, and agent performance monitoring — all within
                            a unified system.
                        </p>

                        <p className="mb-3 ps-1">
                            The platform includes smart property match-making, automated lead assignment, booking and viewing scheduler,
                            CRM features, document workflow automation, and a centralized dashboard — ensuring higher closing rates,
                            faster client response, and improved transparency across all real-estate operations.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> MyLondonHome
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">United Kingdom (London)</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
                        <p className="mb-3 ps-3">
                            Real-Estate CRM, Property Listing Engine, Smart Client Matching System, Broker Workflow Manager,
                            React, Node.js, Firebase, REST APIs, Document Management, Lead Automation Modules,
                            Booking Scheduler, Performance Analytics Dashboard
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
                        <p className="mb-3 ps-3">Real-Estate, Property Management & Brokerage Automation</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
                        <p className="mb-3 ps-3">
                            UI/UX Designer, 2 Frontend Engineers, Backend Architect, Real-Estate Workflow Specialist,
                            Automation Engineer, QA Engineer
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
                        <p className="mb-4 ps-3">4 Months</p>

                        <p className="mb-4 ps-3">
                            MyLondonHome centralizes all real-estate operations — from property listings, clients, and leads to
                            negotiations, agreements, and commission tracking. It replaces manual spreadsheets and scattered workflows
                            with a structured, automated, and intelligent ecosystem designed specifically for the real-estate market.
                            <br /><br />
                            Integrating smart lead routing, client-property match algorithms, automated document workflows, and real-time
                            analytics, the platform enhances the efficiency of brokers, increases closing probability, and boosts overall
                            operational productivity.
                            Agents, admin teams, and management collaborate seamlessly with complete visibility across all property and
                            brokerage activities.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="MyLondonHome UI"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="MyLondonHome Features"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            We built MyLondonHome with a real-estate-first architecture designed for automation, fast response times,
                            and seamless integration across agents, admins, and clients. The system handles property listings, client
                            interactions, appointments, negotiations, contract workflows, and performance metrics — all in one place.
                        </p>

                        <p className="mb-3 ps-1">
                            The UI/UX was crafted to ensure agents can instantly access listings, client histories, and lead pipelines.
                            With an intuitive, role-based interface, brokers can manage viewings, track offers, monitor deal status,
                            automate follow-ups, and collaborate with teams effortlessly.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">End-to-end real-estate CRM for brokers & agencies</li>
                            <li className="mb-1">Smart property matching algorithm for client preferences</li>
                            <li className="mb-1">Automated lead assignment & follow-up tracking</li>
                            <li className="mb-1">Property listing engine with media, pricing & status updates</li>
                            <li className="mb-1">Viewings & appointment scheduler with notifications</li>
                            <li className="mb-1">Deal tracking, negotiation workflow & commission calculator</li>
                            <li className="mb-1">Analytics dashboard for agent performance & sales insights</li>
                            <li className="mb-1">Document workflow automation (agreements, KYC, contracts)</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>


        </>
    )
}

export default MyLondonHome